import { useEffect, useRef } from "react";

export const HomeContent = () => {
  const textRef = useRef(null);

  useEffect(() => {
    const elements = textRef.current?.querySelectorAll("[data-reveal]");
    if (!elements) return;
    elements.forEach((el, i) => {
      el.style.opacity = "0";
      el.style.transform = "translateY(18px)";
      el.style.transition = `opacity 0.7s ease ${i * 0.12}s, transform 0.7s ease ${i * 0.12}s`;
      requestAnimationFrame(() => {
        setTimeout(() => {
          el.style.opacity = "1";
          el.style.transform = "translateY(0)";
        }, 80);
      });
    });
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-screen grid grid-cols-1 lg:grid-cols-2 overflow-hidden"
    >
      {/* ── Photo column ── */}
      <div className="relative h-[55vh] lg:h-screen order-first">
        <img
          src="/images/noah-fernandes-field.jpg"
          alt="Noah Fernandes standing in an open field, holding a wooden staff, looking into the distance"
          className="w-full h-full object-cover object-top"
        />
        {/* Fade to cream on the right (desktop) */}
        <div className="hidden lg:block absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-cream" />
        {/* Fade to cream at the bottom (mobile) */}
        <div className="lg:hidden absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-cream" />
      </div>

      {/* ── Text column ── */}
      <div
        ref={textRef}
        className="flex flex-col justify-center px-8 py-16 lg:px-12 lg:py-24 bg-cream"
      >
        {/* Eyebrow */}
        <p
          data-reveal
          className="text-[0.65rem] tracking-[0.3em] uppercase text-earth-mid mb-6 font-jost font-light"
        >
          Sound healer &nbsp;·&nbsp; Musician &nbsp;·&nbsp; Amsterdam
        </p>

        {/* Headline */}
        <h1
          data-reveal
          className="font-cormorant font-light text-ink leading-[1.05] mb-3"
          style={{ fontSize: "clamp(3rem, 5vw, 5.5rem)" }}
        >
          Music is
          <br />
          <em className="font-light italic text-earth">medicine.</em>
        </h1>

        {/* Sub-headline */}
        <p
          data-reveal
          className="font-cormorant italic font-light text-earth-light mb-8"
          style={{ fontSize: "clamp(1.1rem, 1.8vw, 1.5rem)" }}
        >
          And I know how to use it.
        </p>

        {/* Divider */}
        <div data-reveal className="w-10 h-0.5 bg-earth mb-8" />

        {/* Body */}
        <p
          data-reveal
          className="font-jost font-light text-stone leading-[1.9] mb-10 max-w-[420px]"
          style={{ fontSize: "clamp(0.9rem, 1.1vw, 1rem)" }}
        >
          I guide people through transformation using live music, sound and deep
          inner work — rooted in the science of sound healing, and trained as a
          coach and counsellor in trauma, grief, relationships and parts work.
        </p>

        {/* CTAs */}
        <div data-reveal className="flex flex-wrap gap-3">
          <a
            href="#book"
            className="inline-block px-8 py-3.5 bg-ink text-cream font-jost font-light text-[0.72rem] tracking-[0.18em] uppercase transition-colors duration-300 hover:bg-earth"
          >
            Book a session
          </a>
          <a
            href="#work"
            className="inline-block px-8 py-3.5 border border-earth-light text-earth font-jost font-light text-[0.72rem] tracking-[0.18em] uppercase transition-all duration-300 hover:bg-sand hover:border-earth"
          >
            Explore the work
          </a>
        </div>
      </div>
    </section>
  );
};
